(function () {
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let zoomFrame = null;

  function updateImageZoom() {
    zoomFrame = null;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    document.querySelectorAll('.product-whats-inside__media-column[data-imgzoom] img.product-whats-inside__media').forEach(function (media) {
      if (reducedMotionQuery.matches) {
        media.style.setProperty('--product-whats-inside-image-scale', '1');
        return;
      }

      const rect = media.getBoundingClientRect();
      const animationDistance = viewportHeight + rect.height * 0.5;
      const progress = Math.min(1, Math.max(0, (viewportHeight - rect.top) / animationDistance));
      const scale = 1.2 - progress * 0.2;
      media.style.setProperty('--product-whats-inside-image-scale', scale.toFixed(4));
    });
  }

  function requestImageZoomUpdate() {
    if (zoomFrame) return;
    zoomFrame = window.requestAnimationFrame(updateImageZoom);
  }

  function initSection(section) {
    if (!section || section.dataset.productWhatsInsideReady) return;

    section.dataset.productWhatsInsideReady = 'true';

    section.querySelectorAll('[data-collapsible-row]').forEach(function (row) {
      const toggle = row.querySelector('[data-collapsible-toggle]');
      const panel = row.querySelector('[data-collapsible-panel]');
      const content = row.querySelector('[data-collapsible-content]');

      if (!toggle || !panel || !content) return;

      const renderedText = content.textContent.replace(/\s+/g, ' ').trim();
      const isExpandable = renderedText.length > 150;

      row.classList.toggle('is-expandable', isExpandable);
      content.classList.toggle('t14-12', isExpandable);
      content.classList.toggle('t17-16', !isExpandable);
      toggle.hidden = !isExpandable;

      if (!isExpandable) {
        panel.style.height = 'auto';
        return;
      }

      const collapsedHeight = function () {
        const lineHeight = parseFloat(window.getComputedStyle(content).lineHeight) || 20;
        return lineHeight * 2;
      };

      const update = function () {
        const closedHeight = collapsedHeight();
        panel.style.height = row.classList.contains('is-open') ? content.scrollHeight + 'px' : closedHeight + 'px';
      };

      const toggleContent = function () {
        const isOpen = row.classList.toggle('is-open');

        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        panel.style.height = isOpen ? content.scrollHeight + 'px' : collapsedHeight() + 'px';
      };

      toggle.addEventListener('click', toggleContent);

      panel.addEventListener('click', function (event) {
        if (event.target.closest('a, button')) return;
        toggleContent();
      });

      update();

      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(update);
        observer.observe(content);
        row.productWhatsInsideObserver = observer;
      }
    });

    const slider = section.querySelector('.product-whats-inside__swiper');

    if (slider && slider.querySelectorAll('.swiper-slide').length > 1 && typeof Swiper !== 'undefined') {
      section.productWhatsInsideSwiper = new Swiper(slider, {
        slidesPerView: 1,
        speed: 500,
        pagination: {
          el: section.querySelector('.product-whats-inside__pagination'),
          clickable: true
        }
      });
    }

    requestImageZoomUpdate();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-product-whats-inside]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    window.addEventListener('scroll', requestImageZoomUpdate, { passive: true });
    window.addEventListener('resize', requestImageZoomUpdate);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const section = event.target.querySelector('[data-product-whats-inside]');

    if (section && section.productWhatsInsideSwiper) {
      section.productWhatsInsideSwiper.destroy(true, true);
    }

    if (section) {
      section.querySelectorAll('[data-collapsible-row]').forEach(function (row) {
        if (row.productWhatsInsideObserver) row.productWhatsInsideObserver.disconnect();
      });
    }
  });
})();
